import moment from 'moment';

import ABTest from '../../../modules/abTest';
import analytics from '../../../modules/analytics';
import FeatureFlags from '../../../modules/FeatureFlags';
import stateManager from '../../../modules/user/stateManager';

export const INCENTIVE_TEST_FLY_2609_PRIMARY_SWITCH = 'pro-incentiveinviteswitch-primary-20201211-fly2609';
export const INCENTIVE_TEST_FLY_2609_SECONDARY_SWITCH = 'pro-incentiveinviteswitch-secondary-20201211-fly2609';
export const INCENTIVE_TEST_FLY_2609_KEY = 'pro-incentiveinvitetest-20201211-fly2609';
export const INCENTIVE_COLLAPSE_COUNT_KEY = 'pro-incentiveinvitecollapsecount-20201211-fly2609';
export const INCENTIVE_MODAL_KEY = 'pro-incentiveinvitemodal-20201211-fly2609';
export const INVITED_CLIENTS_KEY = 'invitedClients';
export const IG_MODAL_VIEWED_KEY = 'viewedIGSweepsCelebration';
export const INVITE_COUNT_THRESHOLD = 5;

/**
 * Function to check to see if we can:
 *   1. assign new pros to the incentive test
 *   2. show the promotion ui for pros who have been assigned to test
 * @param {string} providerCreationTime - the datetime the provider joined styleseat
 * @param {number} numClients - number of clients the provider has
 * @return {promise} - whether or not the pro is in the invite incentive test [fly-2609]
 */
export const isInInviteIncentiveTest = async (
  providerCreationTime,
  numClients,
) => {
  const flags = await FeatureFlags.areEnabled([
    INCENTIVE_TEST_FLY_2609_PRIMARY_SWITCH,
    INCENTIVE_TEST_FLY_2609_SECONDARY_SWITCH,
  ]);
  const primarySwitchEnabled = flags[INCENTIVE_TEST_FLY_2609_PRIMARY_SWITCH];
  const secondarySwitchEnabled = flags[INCENTIVE_TEST_FLY_2609_SECONDARY_SWITCH];

  const isNewPro = providerCreationTime
    ? moment.utc().isBefore(moment.utc(providerCreationTime).add('days', 30))
    : false;

  const isEligible = isNewPro && numClients === 0;

  if (primarySwitchEnabled || secondarySwitchEnabled) {
    if (isEligible) {
      return ABTest.isInTest(
        INCENTIVE_TEST_FLY_2609_KEY,
        0.5,
        { skipAssign: !primarySwitchEnabled },
      );
    }

    return ABTest.isInTest(
      INCENTIVE_TEST_FLY_2609_KEY,
      0.5,
      { skipAssign: true },
    );
  }
  return false;
};

/**
 * Updates the collapse count on the IncentiveToAdd component, stores count in user state
 * Is used to determine if initial render of component should be collapsed
 */
export const updateIncentiveCollapseCount = () => {
  stateManager.getActionValue(INCENTIVE_COLLAPSE_COUNT_KEY)
    .then(count => {
      if (!count || count < 2) {
        const updatedCount = count ? (count + 1) : 1;
        stateManager.addAction(INCENTIVE_COLLAPSE_COUNT_KEY, updatedCount);
      }
    });
};

/**
 * Sends tracking event when the goal for the incentive to add test (fly-2609) has been met
 * Provider must be assigned to the test group in order to meet goal
 * @param {number} inviteCount - the count of unique clients that have
 *                               been sent the invite to book sms
 */
export const trackIncentiveToAddGoalMet = async (inviteCount, isP1cComplete) => {
  const isInTest = await isInInviteIncentiveTest();
  if (isInTest && inviteCount >= INVITE_COUNT_THRESHOLD && isP1cComplete) {
    analytics.track('pro_clients_instagram_incentivegoalmet', { invite_count: inviteCount });
    return true;
  }
  return false;
};

/**
 * function to determine if the pro has met the goal to win the chance to be featured on instagram
 * @param {number} inviteCount - the number of clients that have been sent the invite to SS sms
 * @param {boolean} isP1cComplete - if pro is phase one complete
 */
export const hasReachedGoal = (inviteCount = 0, isP1cComplete) => (
  (inviteCount >= INVITE_COUNT_THRESHOLD) && isP1cComplete
);
